export const TINYMCE_KEY = "gfb12ffj0ihlz02p6qhv3pdqomy8712802yyncdgbdz3yxe1";
